import { AreaBranches, ZoneUUIDnData, AreaUUIDnData, AggregateLookupResponse, DeliveryAreaZones } from "./models/restaurant.model";
import { store } from "./store/store";
import { URLBuilder as urlBuilder, cityAreaFromURL }  from '../../modules/helper';
import { cookies, filters , userType } from "./constants/constants";
import { photosUrlEnum } from "./constants/constants";
import { Language } from "../../middlewares/language";
import { staticContent } from "./localisation/detect-lang";
import { Basket } from "./models/basket.model";
import moment = require("moment");
import { getCookie } from './constants/constants'

export const isRTL: boolean = (getCookie(cookies.lang) == Language.ARABIC);

export const updatePhotosURL = (url: string, version: string, ext: string = photosUrlEnum.ext.JPG) => {
  if(url){ // check if url not null or false
    return url.replace(photosUrlEnum.placeholders.version, version).replace(photosUrlEnum.placeholders.ext, ext)
  }
}


export const flatOrderItems = (orderItems, items, sizes) => {
  return orderItems.reduce((dataObj, current, index) => {
    const itemSize = sizes[current.itemSizeUUID];
    const catName = items[itemSize.itemUUID].categoryName;
    const itemData = {
      itemSizeUUID: current.itemSizeUUID,
      itemName: items[itemSize.itemUUID].name,
      sizeName: itemSize.sizeName,
      sizePrice: itemSize.price,
      quantity: current.quantity,
      comment: current.comment,
      extras: current.extras,
      indexInOrderArray: index
    };
    !dataObj[catName] ? (dataObj[catName] = [itemData]) : dataObj[catName].push(itemData);

    return dataObj;
  }, {});
}

export const ifItemSizeExist = (itemModal, cart) => {
  let exist = '-1';
  let sameExtras = true;

  let itemModalExItems = [];
  
  for(const exCatUUID in itemModal.flatExtraCategories){
    itemModalExItems = itemModalExItems.concat(itemModal.flatExtraCategories[exCatUUID].selectedItems);
  }

  
  
  for (const index in cart.order.items) {
    
    const item = cart.order.items[index];
    
    const itemExItems = item.extras.reduce((exItems, exCat) => exItems.concat(exCat.extraItemSizesUUIDs), []);
    if(itemModalExItems.length == itemExItems.length){

      for(const i in itemModalExItems){
        if(!itemExItems.includes(itemModalExItems[i])){
          sameExtras = false;
          break;
        }
      }

    }else{
      sameExtras = false;
    }

    if (
      item.itemSizeUUID == itemModal.itemData.selectedSizeUUID
      && item.comment == itemModal.itemData.comment
      && sameExtras
    ) {
      exist = index;
      break;
    }
  }
  return exist;
};
export const ifItemCategoryExistInBasket =(categoryUUID:string,basket:Basket,)=>{
  let exist=
  basket.data.categories.findIndex(category => category.categoryUUID === categoryUUID);
 return (exist>-1)
 
}

export const toFixedPrice = (price: number) => {
 price? price=Number(price) : price=0;
  return price.toFixed(2) ;
 
}


export const getUrlParameter = (sParam: string) => {
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLVariables = sPageURL.split('&');
  let sParameterName;
  let i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
  return null;
}
export const getUrlSlash = (slash: string) => {
  let filteredUrl = decodeURIComponent(window.location.href).split('/').filter((item) => item.includes(slash));
  return filteredUrl.length ? filteredUrl[0].split(slash)[1] : '';
}

export const buildFiltersURL = (paramsCommaSeparated: string) => {
  return paramsCommaSeparated ? `/${filters.features}-${paramsCommaSeparated}` : '';
}

export const sortMenuItemSizes = (sizesArray) => {
  function compare(a, b) {
    if (a.price < b.price)
      return -1;
    if (a.price > b.price)
      return 1;
    return 0;
  }
  return sizesArray.sort(compare);
}

export const flatMenuItems = (menuObj) => {
  const itemsObj = menuObj.categories.reduce((items, category) => {

    for (let i = 0, length = category.items.length; i < length; i++) {
      items[category.items[i].uuid] = Object.assign(category.items[i], {
        itemUUID: category.items[i].uuid,
        categoryName: category.name,
        categoryAvailableForDelivery: category.availability.availableForDelivery,
        sizes: sortMenuItemSizes(category.items[i].sizes), 
      });

    }

    return items;

  }, {});

  return itemsObj;

}
export const flatSizes = (itemsObj) => {
  const sizesObj = Object.keys(itemsObj).reduce((sizes, itemKey) => sizes.concat({
    itemUUID: itemKey,
    sizes: itemsObj[itemKey].sizes
  }), []).reduce((sizesObj, itemSizes) => {
    for (let i = 0, length = itemSizes.sizes.length; i < length; i++) {

      sizesObj[itemSizes.sizes[i].itemSizeUUID] = Object.assign({
        itemUUID: itemSizes.itemUUID,
        uuid: itemSizes.sizes[i].itemSizeUUID,
        sizeUUID: itemSizes.sizes[i].sizeUUID,
        sizeName: itemSizes.sizes[i].sizeName,
      }, itemSizes.sizes[i]);

    }

    return sizesObj;

  }, {});

  return sizesObj;
}

export const flatDeliveryAreaZones = (deliveryAreaZones) => {

  return deliveryAreaZones.reduce((areasObj, area) => {

    areasObj[area.area.uuid] = Object.assign({}, area.area.data, {
      zones: Object.assign([], area.zones)
    });

    return areasObj;
  }, {});

}

export const flatDeliveryZones = (deliveryAreaZones) => {
  
    return deliveryAreaZones.reduce((allZones, area) => {
  
      allZones = allZones.concat(area.zones);
  
      return allZones;
    }, []).reduce((zonesObj, zone) => {
  
      store.state.restaurantDeliveryData.allDeliveryFee
        ? store.state.restaurantDeliveryData.allDeliveryFee.push(zone.deliveryFee)
        : store.state.restaurantDeliveryData.allDeliveryFee = [zone.deliveryFee];
      zone.deliveryDuration &&
      (  store.state.restaurantDeliveryData.allDeliveryDuration
        ? store.state.restaurantDeliveryData.allDeliveryDuration.push(zone.deliveryDuration)
          : store.state.restaurantDeliveryData.allDeliveryDuration = [zone.deliveryDuration]
      )
  
  
      zonesObj[zone.zone.uuid] = {
        deliveryFee: zone.deliveryFee,
        deliveryDuration: zone.deliveryDuration,
        name: zone.zone.data.name,
        centerLocation: zone.zone.data.centerLocation
      };
  
      return zonesObj;
  
    }, {});
  
  }

  export const flatBranchZones = (branchDeliveryAreaZones) => {
    
    
      return branchDeliveryAreaZones.reduce((allZones, area) => {
    
        allZones = allZones.concat(area.zones);
    
        return allZones;
      }, []).reduce((zonesObj, zone) => {
    
    
        zonesObj[zone.zone.uuid] = {
          deliveryFee: zone.deliveryFee,
          deliveryDuration: zone.deliveryDuration,
          name: zone.zone.data.name,
          centerLocation: zone.zone.data.centerLocation
        };
    
        return zonesObj;
    
      }, {});
    
    }

    const isWithInTime=(from,to)=>{  
      if(from){
        let oldFormat = 'HH:mm:ss';
        let newFormat = 'HHmmss';
        let openingTime = moment(from, oldFormat).format(newFormat);
        let closingTime = moment(to, oldFormat).format(newFormat);
        let timeNow = moment().format(newFormat);  // getting current time from user's local device
        return timeNow >= openingTime && timeNow < closingTime
      }
      else
      return false
    }

    export const isWithinDeliveryHours = (deliveryHours, dailyDeliveryHours)=> {
        if(dailyDeliveryHours[(new Date()).getDay()].closed || isWithInTime(dailyDeliveryHours[(new Date()).getDay()].gapHours.start,dailyDeliveryHours[(new Date()).getDay()].gapHours.end)){
          return false
        }
        else{
        if (deliveryHours) {
          let oldFormat = 'HH:mm:ss';
          let newFormat = 'HHmmss';
          let openingTime = moment(deliveryHours.start, oldFormat).format(newFormat);
          let closingTime = moment(deliveryHours.end, oldFormat).format(newFormat);
          let timeNow = moment().format(newFormat);  // getting current time from user's local device
          // but, should API return the opening/closing time with timezone to solve it forever
          return openingTime == closingTime || // open 24 hours
            (openingTime < closingTime && openingTime < timeNow && closingTime > timeNow) ||  // both open and close in the same day
            (
              openingTime > closingTime && // open <  midnight close after midnight 10 pm to 2 am
              (
                (openingTime < timeNow && closingTime < timeNow) || // <  midnight part 11 pm
                (openingTime > timeNow && closingTime > timeNow)  // after midnight part 1 am
              )
            );
        }
        }
      }


export const isWithinTimeFrame = (openingTime: string, closingTime: string) => {
  let openDateObject=moment(openingTime, "HH:mm:ss");
  let closeDateObject=closingTime<openingTime? moment(closingTime, "HH:mm:ss").add(1,"days"): moment(closingTime, "HH:mm:ss")
  return moment().isBetween(openDateObject,closeDateObject,undefined, '[]')
}

export const orderingFlag =  (content, isDelivers, isDeliversToUser, restOrderFlag, branchOrderFLag, areaOrderFlag, isOpenForDelivery, areaName) => {
  if (isDelivers && isDeliversToUser && restOrderFlag && branchOrderFLag && areaOrderFlag && isOpenForDelivery)
    return { 'message': content.restaurant.deliversTo, 'orderingFlag': true, 'iconFlag': true, 'isOnline':true}
  else if (isDelivers && !areaName && restOrderFlag && branchOrderFLag && isOpenForDelivery) //handling users with no area selected
    return { 'message': content.restaurant.deliversTo, 'orderingFlag': true, 'iconFlag': true, 'isOnline':true}
    else if (!isDelivers)
    return { 'message': content.restaurant.noDeliveryIn, 'orderingFlag': false, 'iconFlag': false, 'isOnline': false}
  else if (!isDeliversToUser)
    return { 'message': content.restaurant.noDeliveryIn, 'orderingFlag': restOrderFlag, 'iconFlag': false, 'isOnline': false}
  else if (areaOrderFlag && !isOpenForDelivery)
    return { 'message': content.restaurant.deliversTo, 'orderingFlag': restOrderFlag, 'iconFlag': true, 'isOnline': false}
  else if(!restOrderFlag||!branchOrderFLag) 
    return { 'message': content.restaurant.deliversTo, 'orderingFlag': false, 'iconFlag': true, 'isOnline': false}

    else
    return { 'message': content.restaurant.deliversTo, 'orderingFlag': restOrderFlag, 'iconFlag': true, 'isOnline': false}
}

export const flatLookupsCities = (cities) => {

  return cities.reduce((citiesObj, city) => {
    citiesObj[city.uuid] = {
      countryUUID: city.ref.countryUUID,
      name: city.data.name,
    };
    return citiesObj;
  }, {});

}
export const flatLookupsAreas = (areas) => {

  return areas.reduce((areasObj, area) => {
    areasObj[area.uuid] = Object.assign({}, area.data, area.ref);
    return areasObj;
  }, {});

}
export const flatCityAreas = (areas) => {

  return areas.reduce((areasObj, area) => {
    areasObj[area.ref.cityUUID] = areasObj[area.ref.cityUUID] || [];
    
    areasObj[area.ref.cityUUID].push({
      uuid: area.uuid,
      name: area.data.name,
      location: Object.assign({}, area.data.location)
    });

    return areasObj;
  }, {});

}
export const flatLookupsZones = (zones) => {
  return zones.reduce((zonesObj, zone) => {
    zonesObj[zone.uuid] = Object.assign({uuid: zone.uuid}, zone.ref, zone.data);
    return zonesObj;
  }, {});

}
export const flatAreaZones = (zones) => {

  return zones.reduce((zonesObj, zone) => {
    zonesObj[zone.ref.areaUUID] = zonesObj[zone.ref.areaUUID] || [];
    
    zonesObj[zone.ref.areaUUID].push({
      uuid: zone.uuid,
      name: zone.data.name,
    });
    
    return zonesObj;
  }, {});

}

export const flatUserAddresses = (userAddresses) => {

  return userAddresses.reduce((addressesObj, address) => {
    
    addressesObj[address.uuid] = Object.assign({uuid: address.uuid}, address.ref, address.data);
    
    return addressesObj;
  }, {});

}

export const formatAMPM = (date) => {
  date = new Date(date);
  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm;
  if(isRTL){
    ampm=hours >= 12 ? 'م' : 'ص';

  }
  else{
    ampm=hours >= 12 ? 'PM' : 'AM';

  }  
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? `0${minutes}` : minutes;
  const strTime = `${hours}:${minutes} ${ampm}`;
  return strTime;
}

export const flatTrackingOrders = (orders) => {
  return orders.data.reduce((ordersObj, order) => {

    ordersObj[order.orderUUID] = Object.assign({uuid: order.orderUUID}, order.ref, order.data, { createdAtAMPM: formatAMPM(order.data.createdAt)})

    return ordersObj;

  }, {});
}

export const flatDeliveryCategories = (categories) => {
  return categories.reduce((categoriesObj, category) => {

    categoriesObj[category.tag.uuid] = {
      uuid: category.tag.uuid,
      name: category.tag.data.name,
      description: category.tag.data.description,
      photo: category.tag.data.photo,
      delivery: category.tag.data.delivery,
      dineOut: category.tag.data.dineout,
      restaurantsCount: category.restaurantsCount
    }
    categoriesObj[URLBuilder.dasher(category.tag.data.name)] = {
      uuid: category.tag.uuid,
      name: category.tag.data.name,
      description: category.tag.data.description,
      photo: category.tag.data.photo,
      delivery: category.tag.data.delivery,
      dineOut: category.tag.data.dineout,
      restaurantsCount: category.restaurantsCount
    }
    
    return categoriesObj;

  }, {});
}

export const flatBranchDeliveryAreaZones = (branchDeliveryAreaZones: DeliveryAreaZones[]) => {
  return branchDeliveryAreaZones.reduce((flatAreas, area) => {
    flatAreas[area.area.uuid] = {
      area: area.area,
      zones: area.zones
    }
    return flatAreas;
  }, {})
}

export const getFlatAreaBranches = (areasBranches) => {
  return areasBranches.reduce((flatAreaBranches, area) => {
    flatAreaBranches[area.area.uuid] = Object.assign(
        { uuid: area.area.uuid },
        area.area.ref,
        area.area.data,
        { branches: area.branches } 
      );
    return flatAreaBranches;
  }, {});
}





export const sortLookupsAreas = (areasArray) => {
  function compare(a, b) {
    if (a.data.name < b.data.name)
      return -1;
    if (a.data.name > b.data.name)
      return 1;
    return 0;
  }
  return areasArray.sort(compare);
}

export const flatLookupsFeatures = (features) => {
  
  return features.reduce((flatFeatures, feature) => {
    flatFeatures[feature.uuid] = {
      uuid: feature.uuid,
      name: feature.data.name,
      description: feature.data.description,
      photo: feature.data.photo,
      delivery: feature.data.delivery,
      dineOut: feature.data.dineOut,
      cities: feature.data.cities
    }

    return flatFeatures;
    
  }, {});

}


export const flatDineoutMoods = (moods) => {
  
  return moods.reduce((flatMoods, mood) => {
    flatMoods[mood.tag.uuid] = {
      uuid: mood.tag.uuid,
      name: mood.tag.data.name,
      description: mood.tag.data.description,
      photo: mood.tag.data.photo,
      delivery: mood.tag.data.delivery,
      dineOut: mood.tag.data.dineOut,
      restaurantsCount: mood.restaurantsCount
    }
    flatMoods[urlBuilder.dasher(mood.tag.data.name)] = {
      uuid: mood.tag.uuid,
      name: mood.tag.data.name,
      description: mood.tag.data.description,
      photo: mood.tag.data.photo,
      delivery: mood.tag.data.delivery,
      dineOut: mood.tag.data.dineOut,
      restaurantsCount: mood.restaurantsCount
    }

    return flatMoods;
    
  }, {});

}


export const flatDineoutCategories = (categories) => {
  
  return categories.reduce((flatCategories, category) => {
    flatCategories[category.tag.uuid] = {
      uuid: category.tag.uuid,
      name: category.tag.data.name,
      description: category.tag.data.description,
      photo: category.tag.data.photo,
      delivery: category.tag.data.delivery,
      dineOut: category.tag.data.dineOut,
      restaurantsCount: category.restaurantsCount
    }
    flatCategories[urlBuilder.dasher(category.tag.data.name)] = {
      uuid: category.tag.uuid,
      name: category.tag.data.name,
      description: category.tag.data.description,
      photo: category.tag.data.photo,
      delivery: category.tag.data.delivery,
      dineOut: category.tag.data.dineOut,
      restaurantsCount: category.restaurantsCount
    }

    return flatCategories;
    
  }, {});

}
   


export const dateFromNow = (date) => {
  const today = new Date().getTime();
  const lastUpdate = new Date(date).getTime();
  const ago = (today - lastUpdate) / 1000;

  const min = 60;

  const hour = min * min;

  const day = hour * 24;

  if (ago >= day) {
    if(isRTL){
    return `من ${parseInt("" + (ago / day))} يوم`;

    }
    else{
    return `${parseInt("" + (ago / day))} day(s) ago`;

    }
  }
  else if (ago >= hour) {
    if(isRTL){
      return `من ${parseInt("" + (ago / hour))} ساعة`;
  
      }
      else{
        return `${parseInt("" + (ago / hour))} hour(s) ago`;
  
      }
  }
  else if (ago >= min) {
    if(isRTL){
      return `من ${parseInt("" + (ago / min))} دقيقة`;
  
      }
      else{
        return `${parseInt("" + (ago / min))} min(s) ago`;
  
      }
  }
  else {
    if(isRTL){
      return `من ${parseInt("" + ago)} ثانية`;
  
      }
      else{
        return `${parseInt("" + ago)} sec(s) ago`;
  
      }
  }
}

export const getScrollbarWidth = () => {
  var scrollDiv = document.createElement("div");
  scrollDiv.className = "scrollbar-measure";
  document.body.appendChild(scrollDiv);

  // Get the scrollbar width
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  
  // Delete the DIV 
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;

}
// header scripts
export const fixBodyScrollbarWidth = (className) => {
  $('body, #header').css({
    paddingRight: document.getElementsByTagName('body')[0].classList.contains(className) ? getScrollbarWidth() + 'px' : 0
  });
}
export const navBtnHandler = () => {
  document.getElementsByTagName('body')[0].classList.toggle('nav-opened');
  fixBodyScrollbarWidth('nav-opened');
}
export const pushGoogleAnalyticsEvent = (event, event_label, event_category) => {
  window['gtag']('event', event, {
    'event_label': event_label,
    'event_category': event_category
  });
}
export const pushAnalyticsEvent = (event_category, event, event_label=null, event_value=null) => {
  window['gtag']('event', event, {
    'event_label': event_label,
    'event_category': event_category,
    'value': event_value
  });
}
export const pageReferToSourceScreen = (pagereferer: string) => {
  if (pagereferer.indexOf('elmenus') > 0) {
  if (pagereferer.indexOf('/search') > 0)
    return 'search: results screen'
  else if (pagereferer.indexOf('/delivery') > 0) {
    return (pagereferer.indexOf('dish-') > 0) ?
      'Delivery: dish discovery' : 'Delivery: all restaurants'
    }
  else if (pagereferer.indexOf('/dineout') > 0) {
     if (pagereferer.indexOf('/mood-hidden-gems') > 0)
      return 'Dine out: hidden gems'
    else if (pagereferer.indexOf('/top-restaurants') > 0)
      return 'Dine out: top area'
    else if (pagereferer.indexOf('/mood-') > 0)
      return 'Dine out: moods'
    else if (pagereferer.indexOf('/dish-') > 0)
      return 'Dine out: dishes'
    else if (pagereferer.indexOf('/new-restaurants') > 0)
      return 'Dine out: new'
    else
      return 'Dine out: landing page'
    }
  else {
    return 'Restaurant: related restaurant'
    }
  }
  else {
    return 'Parachute User'
  }
    
}
export const pushAnalyticsVariable = (variables) => {
  window['dataLayer'].push(variables);
}

export const isLoggedInUser = () => {
  const {state : {profile}} = store;
  return profile.data.shortCode !== userType.GUEST;
};

export const pushMixpanelEvent = (event, properties = {}) => {
  const isUser = isLoggedInUser();
  if (isUser) {
    window["mixpanel"].track(event, { ...properties });
  }
};

export async function sha256(str) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder("utf-8").encode(str));
  return Array.prototype.map.call(new Uint8Array(buf), x => (('00' + x.toString(16)).slice(-2))).join('');
}

export const mixPanelIdentifyUser=(userUUID)=>{
  const isUser = isLoggedInUser();
  if(isUser){
    window["mixpanel"].identify(userUUID);
  }
}
export const counter = (method: string, num: number) => {
  switch (method) {
    case "add":
      num++;
    break;
    case "substract":
      num > 1 && num--;
    break;
    default:
    break;
  }
  return num;
}

export const getCityAreaFromURL = (pathName, lookups: AggregateLookupResponse) => {
  pathName = decodeURIComponent(pathName);
  let params = pathName.split('/').filter( r => r);
  let lang = getCookie(cookies.lang);
  return cityAreaFromURL(params, lang, lookups);
};

export const URLBuilder = urlBuilder;



export const validateRestaurantMinOrderValue = (subTotal, minimumOrderValue) => {
  return minimumOrderValue ? (subTotal >= minimumOrderValue) : true;
}


export const addClassToElements=(selector,className)=>{

  let element = document.getElementsByClassName(selector);
  for (let index = 0; index < element.length; index++) {
    element[index].classList.add(className);  
  }

}
export const removeClassFromElements=(selector,className)=>{
  let element = document.getElementsByClassName(selector);
  for (let index = 0; index < element.length; index++) {
    element[index].classList.remove(className);  
  }
}
export const removeClassFromSelector=(selector,className)=>{
  let element = document.querySelectorAll(selector);
  for (let index = 0; index < element.length; index++) {
    element[index].classList.remove(className);  
  }
}
export const removeElementByClass=(className)=>{
  let element=document.getElementsByClassName(className)
  for (let index = 0; index < element.length; index++) {
    element[index].remove();  
  }
}

export const closestByClass = function(el, className) {
  while (el.classList && !el.classList.contains(className)) {
      el = el.parentNode;
      
      if (!el) {
          return [];
      }
  }
  
  if(el.classList && el.classList.contains(className)){
    return [el];

  }
  else{
    return [];

  }
}
export const closestById = function(el, id) {
  while (el.id != id) {
      el = el.parentNode;
      if (!el) {
          return [];
      }
  }

  if(el && el.id == id){
    return [el];

  }
  else{
    return [];

  }
}